import React from 'react';
import './Contact.css';
import { ContactInfo } from '../components/ContactInfo';
import { siteInfo } from '../data/siteInfo';
import { Seo, buildBreadcrumbSchema, buildCafeSchema } from '../components/Seo';

function Contact() {
    const embeddedMapUrl = `https://www.google.com/maps?q=${encodeURIComponent(siteInfo.mapQuery)}&output=embed`;

    return (
        <div className='contact-page'>
            <Seo
                title='Kontakt'
                description='Kontaktieren Sie Sarita&apos;s in Hinwil oder planen Sie Ihren Besuch am Bahnhofplatz 1. Hier finden Sie Adresse, Öffnungszeiten, Telefonnummer und Karte.'
                path='/contact'
                schema={[
                    buildCafeSchema(),
                    buildBreadcrumbSchema([
                        { name: 'Startseite', path: '/' },
                        { name: 'Kontakt', path: '/contact' }
                    ])
                ]}
            />
            <header className='page-hero contact-hero'>
                <div className='container page-hero__content'>
                    <h1 className='page-hero__title'>Kontakt</h1>
                </div>
            </header>

            <section className='section-shell'>
                <div className='container'>
                    <div className='contact-layout'>
                        <div className='contact-layout__info'>
                            <ContactInfo />
                        </div>
                        <div className='contact-layout__content panel-surface'>
                            <p className='section-eyebrow'>Standort</p>
                            <h2>Hier finden Sie uns</h2>
                            <div className='contact-layout__map-wrap'>
                                <iframe
                                    title={`Google Map ${siteInfo.mapQuery}`}
                                    src={embeddedMapUrl}
                                    loading='lazy'
                                    referrerPolicy='no-referrer-when-downgrade'
                                    allowFullScreen
                                />
                            </div>
                            <div className='contact-layout__actions'>
                                <a
                                    href={`https://maps.google.com/?q=${encodeURIComponent(siteInfo.mapQuery)}`}
                                    className='btn-sarita'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    In Google Maps öffnen
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
